import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description WhatsApp icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { WhatsApp } from '@sravni/design-system-icons'
 *
 * <WhatsApp />
 * ```
 */
var WhatsApp = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "WhatsApp", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.6 4.3C14.1 2.8 12.1 2 10 2 5.6 2 2.1 5.6 2.1 9.9c0 1.4.4 2.8 1.1 4L2 18l4.2-1.1c1.2.6 2.5 1 3.8 1 4.4 0 7.9-3.6 7.9-7.9 0-2.2-.8-4.2-2.3-5.7zm-1.7 8.5c-.2.5-1 .9-1.3.9-.3.1-.8.1-1.2-.1-.3-.1-.7-.2-1.1-.4-2-.9-3.3-2.9-3.4-3-.2-.1-.9-1.1-.9-2 0-1 .5-1.5.7-1.7.2-.2.4-.2.5-.2h.4c.1 0 .3 0 .4.3.2.4.6 1.4.6 1.5 0 .1.1.2 0 .3 0 .2-.1.2-.2.4l-.3.3c-.1.1-.2.2 0 .4.1.2.5.8 1.1 1.4.8.7 1.4.9 1.6 1 .2.1.3.1.4 0 .1-.1.5-.6.6-.8.1-.2.3-.2.4-.1.2.1 1.2.5 1.4.6.2.1.3.1.4.2 0 .1 0 .5-.1 1z", fill: "currentColor" }))); });

export { WhatsApp };
//# sourceMappingURL=WhatsApp.js.map
